import React, { useState } from "react";
import API_URL from "../utils/api";

export type AdminUser = { name: string; email: string; is_master_admin?: boolean; staff_role?: string | null };

export default function Login({ onLogin }: { onLogin: (token: string, user: AdminUser) => void }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const res = await fetch(`${API_URL}/auth/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });
      const data = await res.json();
      if (!res.ok) {
        setError(data.error || "Identifiants incorrects");
      // Un modérateur (staff_role='moderator_1'|'2'|'3') n'a pas is_admin — sans ce cas, ce garde
      // rejetait n'importe quel compte staff qui n'est ni admin ni master.
      } else if (!data.user?.is_admin && !data.user?.is_master_admin && !data.user?.staff_role) {
        setError("Ce compte n'a pas accès au panel d'administration");
      } else {
        localStorage.setItem("admin_refresh_token", data.refreshToken || "");
        onLogin(data.accessToken, {
          name: data.user.name, email: data.user.email,
          is_master_admin: !!data.user.is_master_admin, staff_role: data.user.staff_role || null,
        });
      }
    } catch {
      setError("Impossible de se connecter au serveur");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: "100vh",
      backgroundColor: "#0a0a0a",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    }}>
      <div style={{
        backgroundColor: "#1A1A1A",
        borderRadius: 20,
        padding: 40,
        width: 400,
        border: "1px solid #222",
      }}>
        {/* Logo */}
        <div style={{ textAlign: "center", marginBottom: 32 }}>
          <div style={{
            width: 64, height: 64, borderRadius: "50%",
            backgroundColor: "white",
            display: "flex", alignItems: "center", justifyContent: "center",
            margin: "0 auto 12px", overflow: "hidden",
          }}>
            <img src="/oltodo.png" alt="OLTODO" style={{ width: "80%", height: "80%", objectFit: "contain" }} />
          </div>
          <div style={{ color: "#0000FF", fontWeight: 800, fontSize: 24, letterSpacing: 3 }}>OLTODO</div>
          <div style={{ color: "#666", fontSize: 13, marginTop: 4 }}>Panel d'administration</div>
        </div>

        <form onSubmit={handleSubmit}>
          {error && (
            <div style={{
              backgroundColor: "#2D1515",
              border: "1px solid #C0392B",
              borderRadius: 10,
              padding: 12,
              color: "#C0392B",
              fontSize: 13,
              marginBottom: 16,
            }}>{error}</div>
          )}

          <div style={{ marginBottom: 16 }}>
            <label style={{ color: "#999", fontSize: 12, fontWeight: 600, display: "block", marginBottom: 6 }}>
              EMAIL
            </label>
            <input
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              placeholder="admin@oltodo.com"
              style={{
                width: "100%",
                backgroundColor: "#0a0a0a",
                border: "1px solid #333",
                borderRadius: 10,
                padding: "12px 14px",
                color: "white",
                fontSize: 14,
              }}
            />
          </div>

          <div style={{ marginBottom: 24 }}>
            <label style={{ color: "#999", fontSize: 12, fontWeight: 600, display: "block", marginBottom: 6 }}>
              MOT DE PASSE
            </label>
            <input
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              placeholder="••••••••"
              style={{
                width: "100%",
                backgroundColor: "#0a0a0a",
                border: "1px solid #333",
                borderRadius: 10,
                padding: "12px 14px",
                color: "white",
                fontSize: 14,
              }}
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            style={{
              width: "100%",
              backgroundColor: "#0000FF",
              color: "white",
              border: "none",
              borderRadius: 12,
              padding: "14px",
              fontSize: 15,
              fontWeight: 700,
              opacity: loading ? 0.7 : 1,
            }}
          >
            {loading ? "Connexion..." : "Se connecter"}
          </button>
        </form>
      </div>
    </div>
  );
}
